import * as yup from 'yup';
import { ApplicantDTO } from '../../../../api/useAccountApplicantsQuery';
import { CustomerType } from '../../../../../AccountOpening/AccountOpening.meta';
import { emailValidation } from '../../../../../AccountOpening/fields/Email/Email.meta';
import { phoneNumberValidation } from '../../../../../AccountOpening/fields/Phone/Phone.meta';
import {
  cityValidation,
  postalCodeValidation,
  stateValidation,
  streetAddressLine1Validation,
} from '../../../../../AccountOpening/fields/Address/Address.meta';

export interface FormValues {
  primaryApplicant: Omit<ApplicantDTO, 'firstName' | 'lastName'>;
  secondApplicant: Omit<ApplicantDTO, 'firstName' | 'lastName'> | null;
}

export const FORM_ID = 'my-account--summary-form';

const applicantValidation = yup.object().shape({
  email: emailValidation,
  streetAddress: streetAddressLine1Validation,
  state: stateValidation,
  city: cityValidation,
  postalCode: postalCodeValidation,
  phoneNumber: phoneNumberValidation.notRequired(),
});

export const validation = yup.object().shape({
  primaryApplicant: applicantValidation,

  secondApplicant: yup
    .object()
    .when('$accountType', {
      is: CustomerType.Joint,
      then: applicantValidation,
    })
    .nullable(),
});
